export enum AbilityActions {
  create = 'create',
  read = 'read',
  update = 'update'
}

export enum AbilitySites {
  product = 'product',
  submission = 'submission',
  preferences = 'preferences',
  echaprofile = 'echa-profile',
  envoverview = 'env-overview'
}

export enum Role {
  submitter = 'SCIP_SUBMITTER',
  editor = 'SCIP_EDITOR',
  admin = 'SCIP_ADMIN',
  readOnly = 'SCIP_VIEWER'
}
